const closeButton = document.querySelectorAll(".js-notification-close");

if (closeButton) {
  closeButton.forEach((button) => {
    button.addEventListener("click", ()=>{
      notificationClose(button as HTMLButtonElement);
    })
  })
}

const notificationClose = (elm: HTMLButtonElement) => {
  const notificationContent: HTMLElement = elm.parentNode as HTMLElement;
  if (notificationContent) {
    notificationContent.classList.add("c-content__notification--hidden");
    console.log(notificationContent);
  }
}
